import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { ProductShelvingRequirement } from "../../types"
import { getProductShelvingRequirementsBinSizeLabel } from "../../utils"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import { booleanToString } from "@/utils/utils"

interface ProductShelvingRequirementTableProps {
  shelvingRequirement: ProductShelvingRequirement
  onEdit: () => void
}

const ProductShelvingRequirementTable: FC<ProductShelvingRequirementTableProps> = ({ shelvingRequirement, onEdit }) => {
  const { hasPermissions } = usePermissionManager()

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Cold Storage</TableCell>
          <TableCell>H3 Storage</TableCell>
          <TableCell>Bin Size</TableCell>
          <TableCell>Deep</TableCell>
          <TableCell>Stackable</TableCell>
          {hasPermissions([PermissionActionType.WAREHOUSES_MAINTENANCE]) && <TableCell></TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{booleanToString(shelvingRequirement.coldStorage)}</TableCell>
          <TableCell>{booleanToString(shelvingRequirement.h3ColdStorage)}</TableCell>
          <TableCell>{getProductShelvingRequirementsBinSizeLabel(shelvingRequirement.binSize)}</TableCell>
          <TableCell>{booleanToString(shelvingRequirement.deep)}</TableCell>
          <TableCell>{booleanToString(shelvingRequirement.stackable)}</TableCell>
          {hasPermissions([PermissionActionType.WAREHOUSES_MAINTENANCE]) && (
            <TableCell className='text-right'>
              <IconButton color='primary' aria-label='Edit shelving requirements' onClick={onEdit}>
                <EditOutlined />
              </IconButton>
            </TableCell>
          )}
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default ProductShelvingRequirementTable
